import createNumberMask from 'text-mask-addons/dist/createNumberMask'
import IMask from 'imask';
import FitinsurAPI from './fitinsur-api';

const fitinsur = new FitinsurAPI();
export default class MasksHelper {
  constructor(props) {
    this.dict = {
      USphone: {
        default: {
          mask: ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
          regex: '^(\([0-9]{3}\) |[0-9]{3}-)[0-9]{3}-[0-9]{4}$'
        },
      },
      GBphone: {
        default: {
          mask: ['(', /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
          regex: '^(\([0-9]{3}\) |[0-9]{4}-)[0-9]{4}-[0-9]{4}$'
        },
      },
      BRphone: {
        default: {
          mask: ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/],
          regex: '^(\([0-9]{2}\) |[0-9]{5}-)[0-9]{5}-[0-9]{4}$'
        },
      },
      UScurrency: {
        default: {
          mask: {
            delimiter: ',',
            radix: '.',
            type: "currency",
            mask: Number
          },
          regex: "^\$?\-?([1-9]{1}[0-9]{0,2}(\,\d{3})*(\.\d{0,2})?|[1-9]{1}\d{0,}(\.\d{0,2})?|0(\.\d{0,2})?|(\.\d{1,2}))$|^\-?\$?([1-9]{1}\d{0,2}(\,\d{3})*(\.\d{0,2})?|[1-9]{1}\d{0,}(\.\d{0,2})?|0(\.\d{0,2})?|(\.\d{1,2}))$|^\(\$?([1-9]{1}\d{0,2}(\,\d{3})*(\.\d{0,2})?|[1-9]{1}\d{0,}(\.\d{0,2})?|0(\.\d{0,2})?|(\.\d{1,2}))\)$"
        },
      },
      ENcurrency: {
        default: {
          mask: {
            delimiter: ',',
            radix: '.',
            type: "currency",
            mask: Number
          },
          regex: "^\$?\-?([1-9]{1}[0-9]{0,2}(\,\d{3})*(\.\d{0,2})?|[1-9]{1}\d{0,}(\.\d{0,2})?|0(\.\d{0,2})?|(\.\d{1,2}))$|^\-?\$?([1-9]{1}\d{0,2}(\,\d{3})*(\.\d{0,2})?|[1-9]{1}\d{0,}(\.\d{0,2})?|0(\.\d{0,2})?|(\.\d{1,2}))$|^\(\$?([1-9]{1}\d{0,2}(\,\d{3})*(\.\d{0,2})?|[1-9]{1}\d{0,}(\.\d{0,2})?|0(\.\d{0,2})?|(\.\d{1,2}))\)$"
        },
      },
      GBcurrency: {
        default: {
          mask: createNumberMask({
            prefix: '£',
            suffix: '',
            includeThousandsSeparator: true,
            thousandsSeparatorSymbol: ',',
            allowDecimal: true,
            decimalSymbol: '.',
            decimalLimit: 5, // how many digits allowed after the decimal
            integerLimit: 9, // limit length of integer numbers
            allowNegative: false,
            allowLeadingZeroes: false,
          }),
          regex: "^\$?\-?([1-9]{1}[0-9]{0,2}(\,\d{3})*(\.\d{0,2})?|[1-9]{1}\d{0,}(\.\d{0,2})?|0(\.\d{0,2})?|(\.\d{1,2}))$|^\-?\$?([1-9]{1}\d{0,2}(\,\d{3})*(\.\d{0,2})?|[1-9]{1}\d{0,}(\.\d{0,2})?|0(\.\d{0,2})?|(\.\d{1,2}))$|^\(\$?([1-9]{1}\d{0,2}(\,\d{3})*(\.\d{0,2})?|[1-9]{1}\d{0,}(\.\d{0,2})?|0(\.\d{0,2})?|(\.\d{1,2}))\)$"
        },
      }, 
      BRcurrency: {
        default: {
          mask: {
            delimiter: '.',
            radix: ',',
            signed: true,
            type: "currency",
            mask: Number
          },
          regex: "^\$?\-?([1-9]{1}[0-9]{0,2}(\,\d{3})*(\.\d{0,2})?|[1-9]{1}\d{0,}(\.\d{0,2})?|0(\.\d{0,2})?|(\.\d{1,2}))$|^\-?\$?([1-9]{1}\d{0,2}(\,\d{3})*(\.\d{0,2})?|[1-9]{1}\d{0,}(\.\d{0,2})?|0(\.\d{0,2})?|(\.\d{1,2}))$|^\(\$?([1-9]{1}\d{0,2}(\,\d{3})*(\.\d{0,2})?|[1-9]{1}\d{0,}(\.\d{0,2})?|0(\.\d{0,2})?|(\.\d{1,2}))\)$"
        },
      },
      EUcurrency: {
        default: {
          mask: {
            delimiter: ',',
            radix: '.',
            type: "currency",
            mask: Number
          },
          regex: "^\$?\-?([1-9]{1}[0-9]{0,2}(\,\d{3})*(\.\d{0,2})?|[1-9]{1}\d{0,}(\.\d{0,2})?|0(\.\d{0,2})?|(\.\d{1,2}))$|^\-?\$?([1-9]{1}\d{0,2}(\,\d{3})*(\.\d{0,2})?|[1-9]{1}\d{0,}(\.\d{0,2})?|0(\.\d{0,2})?|(\.\d{1,2}))$|^\(\$?([1-9]{1}\d{0,2}(\,\d{3})*(\.\d{0,2})?|[1-9]{1}\d{0,}(\.\d{0,2})?|0(\.\d{0,2})?|(\.\d{1,2}))\)$"
        },
      },
      percentage: {
        default: {
          radix: '.'
        },
        EU: {
          radix: '.',
        },
        BR: {
          radix: ',',
        },
        EN: {
          radix: '.',
        },
        US: {
          radix: '.',
        }
      },
      SGcurrency: {
         default: {
           mask: createNumberMask({
             prefix: 'S$',
             suffix: '',
             includeThousandsSeparator: true,
             thousandsSeparatorSymbol: ',',
             allowDecimal: true,
             decimalSymbol: '.',
             decimalLimit: 2, // how many digits allowed after the decimal
             integerLimit: 9, // limit length of integer numbers
             allowNegative: false,
             allowLeadingZeroes: false,
           }),
           regex: "^\$?\-?([1-9]{1}[0-9]{0,2}(\,\d{3})*(\.\d{0,2})?|[1-9]{1}\d{0,}(\.\d{0,2})?|0(\.\d{0,2})?|(\.\d{1,2}))$|^\-?\$?([1-9]{1}\d{0,2}(\,\d{3})*(\.\d{0,2})?|[1-9]{1}\d{0,}(\.\d{0,2})?|0(\.\d{0,2})?|(\.\d{1,2}))$|^\(\$?([1-9]{1}\d{0,2}(\,\d{3})*(\.\d{0,2})?|[1-9]{1}\d{0,}(\.\d{0,2})?|0(\.\d{0,2})?|(\.\d{1,2}))\)$"
         },
       } 
    }
  }
  getMask(uid, region, fieldMaskScale = 2, fieldMaskLength = null, fieldMaxValue = null, fieldMinValue = null,pad = false) {
    //console.log("getMask - uid: "+uid);
    //console.log("getMask - region: "+region);
    //console.log("getMask - fieldMaskLength: "+fieldMaskLength);
    //console.log("getMask - fieldMaxValue: "+fieldMaxValue);
    //console.log("getMask - fieldMinValue: "+fieldMinValue);
    //console.log("getMask - pad: "+pad);
    //region = region.split('-');
    let regionAux = region.split('-');
    //let c = this.dict[region[0].toUpperCase() + uid];

    let c = this.dict[regionAux[0].toUpperCase() + uid];

    if (c) {
      let p = {}
      if (regionAux.length == 2) {
        //p = { ...c[region[1]].mask }; // 20201220 - original - sprint9
        p = { ...c["default"].mask }; // 20201220 - test1 - sprint9
        //p = { ...c[region[1].toUpperCase()+uid].mask }; // 20201220 - test2 - sprint9
      } else {
        p = { ...c["default"].mask };
      }
      let m = {
        mask: p.mask,
        type:p.type,
        scale: fieldMaskScale,  // digits after point, 0 for integers
        signed: true,  // disallow negative
        thousandsSeparator: p.delimiter,  // any single char
        padFractionalZeros: pad,  // if true, then pads zeros at end to the length of scale
        normalizeZeros: false,  // appends or removes zeros at ends
        radix: p.radix
      }

      if (fieldMaskLength || fieldMinValue) {
        m.max = fieldMaxValue || this.getMax(fieldMaskLength);
      }
      if (fieldMinValue) {
        m.min = fieldMinValue;
      }
      return m;
    }
    return null;
  }

  getMax(i) {
    let e = ""
    for (let index = 0; index < i; index++) {
      e += "9";
    }
    return parseInt(e);
  }

  resolveMask(value,mask){
    if(value != null && mask){
      let m = IMask.createMask(mask);
      m.resolve(value.toString());
      return m.value;
    }
    return value;
   
  }

  getMaskConfig(list,id,region,maxValue = false,pad = false){
    let i = list.find(x => x.id == id);
    if(i){
      if (i?.behavior || i?.beahavior) {
        try {
          let e = i.behavior || i.beahavior;
          if (e.fieldMask) {
            let m;
            if (e.fieldMask == "percentage") {
              m = this.getPercentage(region,e.fieldMaskScale || null, maxValue || e.fieldMaxValue || "9999", e.fieldMinValue || "0");
            }else{
              m = this.getMask(e.fieldMask || null, region, e.fieldMaskScale || null,e.fieldMaskLength || null,maxValue || e.fieldMaxValue || null, e.fieldMinValue || null,pad)
            }
           
            return m;
          }
          return false;
         
        } catch(e) {console.log(e); return false; };
      }
      return false;
    }
    return false;
  }

  getMaskConfigs(idFields,idDomain = null,token){
    return new Promise((resolve,reject) => {
      fitinsur.setAuthToken(token);
      fitinsur.requestConfig(idFields,idDomain).then(x => x.json()).then(res => {
        if(res.ret_code == 200){
          resolve(res.ret_value);
        }else{
          resolve([]);
        }
      }).catch((e) => {console.log(e);  resolve([])}
     );
    });
  }

  getPercentage(region, decimalScale = 5, maxValue = "9999", minValue = "0",pad = false) {
    region = region.split('-');
    return {
      type: "currency",
      mask: '% num',
      blocks: {
        num: {
          mask: Number,
          scale: decimalScale,  // digits after point, 0 for integers
          signed: true,  // disallow negative
          thousandsSeparator: '',  // any single char
          padFractionalZeros: pad,  // if true, then pads zeros at end to the length of scale
          normalizeZeros: false,  // appends or removes zeros at ends
          radix: this.dict?.percentage[region[0]]?.radix || this.dict.percentage["default"].radix,  // fractional delimiter
          min: parseInt(minValue),
          max: parseFloat(maxValue)
        }
      }
    };
  }
}
